<template>
  <div>
    <div>
      <div class="row" style="padding-top: 10px">
        <div class="col-md-6 pull-left" style="text-align: left;padding-left: 50px;">
          <router-link :to="{name:'login'}">
            <img src="../../../assets/img/logo.svg" width="140px" height="70px"></a>
          </router-link>
          <span style="font-size:20px; font-weight: 800;">
            <span style="font-size:32px">GLS</span> TRACKING
          </span>
        </div>
        <div class="col-md-6" style="text-align: right;height:70px;vertical-align: bottom;">
          <router-link :to="{name:'login'}" class="glyphicon glyphicon-home btn btn-link" :title="$t('home')" />
          <a href="javascript:history.go(-1)" class="glyphicon glyphicon-arrow-left btn btn-link" :title="$t('return')"></a>
        </div>
      </div>
      <div class="row">
        <div class="top_trapezoid1 col-sm-2 col-md-2"></div>
        <div class="top_trapezoid2 col-sm-10 col-md-10"></div>
      </div>
    </div>
    <div>
      <page-menu></page-menu>
    </div>
  </div>
</template>

<script>
import PageMenu from "@/components/infrastructure/layout/page-menu.vue";
import pageMenu from "./page-menu.vue";
export default {
  components: { pageMenu },
  comments: [PageMenu],
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/index.css";
@import "../../../assets/css/common.css";

.top_trapezoid1 {
  height: 0;
  border-top: 15px solid #18b832;
  margin-top: 10px;
}
.top_trapezoid2 {
  height: 0;
  margin-left: -5px;
  border-top: 25px solid #18b832;
  border-left: 5px solid transparent;
  margin-top: 10px;
}
</style>